import useLevelSelection from "../../utils/hooks/useLevelSelection.js";
import  React, { useState, useEffect, useMemo, useContext} from "react";
import { Link, NavLink, useParams} from "react-router-dom";
import "./Content.scss";
import { slugify } from "../../utils/slugify.js";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook.js";
import { useLevelContentData } from "../../utils/hooks/translateLevelContentDataHook.js";
import { useLanguage } from "../../context/LanguageContext.js";
import { CurrentUserContext } from "../../context/CurrentUserContext";
import LectureProgressItem from "./LectureProgressItem.jsx"
import Favlogo from './styles/icon/FAVICON.png';
import placeholderMain from "./images/content_big_1440.png";
import placeholderSide from "./images/content_1440.png";
import arrowRight from './styles/icon/arrowRight.svg';
import { courseRegistry } from "../../courses/courseRegistry.js";
import html from "./config.js";
 

const lang = "tr";

const Content = ({ user, setCurrentUser }) => {
  const [openTreeIndex, setOpenTreeIndex] = useState(null); //I am thinking on using side panel - top just profile in small - will be enlarged or a modal open for changing user details  
  const [selectedSubjectIdx, setSelectedSubjectIdx] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const { currentUser } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const { courseSlug} = useParams();
  const courseConfig = courseRegistry[courseSlug];
  const t = useTranslation();
  const { language } = useLanguage();
    const translatedData = useLevelContentData (
      html.levelContentData,
      html.slug
    )
 
  const {
    selectedLevel,
    mergedForSelected,
    userLevelContent
  } = useLevelSelection(user, translatedData, courseSlug);
 
  const levelData = mergedForSelected?.subjects?.map(s => s.title) || [];
  //console.log("USER PROP:", user);
  //console.log("CURRENT USER CONTEXT:", currentUser);
  // console.log("USER SUB LEVEL (prop):", user?.subscriptionLevel);
  // console.log("USER SUB LEVEL (context):", currentUser?.subscriptionLevel);
  /* console.log("Final selected levels:", levelData);
  console.log("Translated contentItems:", translatedData[0].contentItems); */
  console.log("ALL MERGED:", mergedForSelected);
  console.log("Selected Type:", selectedType);
  console.log("setSelectedType", setSelectedType.lectures)
  console.log("subject object", mergedForSelected?.subjects?.[selectedSubjectIdx]);

  useEffect(() => {
    setSelectedType(null);
  }, [selectedSubjectIdx]);


/*   const getNumericSlug = (input = "") => {
    const str = typeof input === "string" ? input : input?.title || "";

    const match = str.match(/(\d+)[\.-](\d+)[\.-](\d+)/);
    return match ? `${match[1]}-${match[2]}-${match[3]}` : "";
  }; */

  const getNumericSlug = (input = "") => {
    let str = "";

    if (typeof input === "string") {
      str = input;
    } else if (typeof input?.title === "string") {
      str = input.title;
    } else if (typeof input?.stableKey === "string") {
      str = input.stableKey;
    }

    const match = str.match(/(\d+)[\.-](\d+)[\.-](\d+)/);
    return match ? `${match[1]}-${match[2]}-${match[3]}` : "";
  };
  
  return (
    <div className="coursehtml">
      <div className="content-section">
        <div className="white-frame">
        <div className="white-frame__content">
          <div className="location-fav">
            <img src={Favlogo} alt="fav" className="fav-icon" />
            <span className="location-separator">|</span>
            <span className="location-text">{t('courses')}</span>
          </div>
          <div className="content-profile">
              <h1>{t('level')?.toUpperCase()} <strong>{userLevelContent?.title?.toUpperCase()}</strong></h1>
          </div>
          <div className="content-info">
              <ul className="contentItems-list">
                  {levelData.map((item, idx) => (
                    <li key={idx} className={`contentItems-item ${selectedSubjectIdx === idx ? "active" : ""}`}
                        onClick={() => { setSelectedSubjectIdx(idx); setSelectedType(null); }}>
                        <img src={arrowRight} alt="" className="arrow-icon1" />{item?.toUpperCase()}
                    </li>
                  ))}     
              </ul>
          </div>
          {/* LEFT PANEL */}
          <div className="map-content-panel">
            {selectedSubjectIdx === null && (
              <div className="center-image"><img src={placeholderMain} alt="select course" /></div>
            )}
            {selectedSubjectIdx !== null && mergedForSelected && (
              <div className="subject-content-wrapper">
                <div className="subject-column">
                  {(() => {
                    const subject = mergedForSelected.subjects[selectedSubjectIdx];
                    return (
                      <div className="subject-block">
                        <div className="subject-title1">{subject.title}</div>
                        <div className="subject-sections">
                          {subject.lectures?.length > 0 && (
                            <div  className={`section-link ${selectedType === "Lessons" ? "selected" : ""}`}
                                  onClick={() =>  setSelectedType("Lessons")}>
                                {t("lessons")}
                            </div>
                          )}
                          <div className={`section-link ${selectedType === "Documents" ? "selected" : ""}`}
                              onClick={() => navigate("/books")}> {/*  setSelectedType("Documents")*/}
                            {t("documents")}
                          </div>
                        </div>
                      </div>
                    )
                  })()}
                </div>
                {/* L PANEL */}
                <div className="content-column">
                  {!selectedType && (<div className="center-image"> <img src={placeholderSide} alt="choose type" /></div>)}

                  {selectedType && (
                    <div className="content-list">
                      {selectedType === "Lessons" &&
                        mergedForSelected.subjects[selectedSubjectIdx].lectures?.map((lecture, i) => {
                          const stableSlug = getNumericSlug(lecture);
  
                          return (
                          <div key={i} className="lecture-item-content">
                            <LectureProgressItem
                              title={lecture.title}
                              //to={`/course/${courseSlug}/lectures/${slugify(lecture.key)}`}
                              to={`/course/${courseSlug}/lectures/${stableSlug}`}
                              allowToggle={false}
                            />
                          </div>
                          )
                        })}

                      {selectedType === "Documents" &&
                        mergedForSelected.subjects[selectedSubjectIdx].docs?.map((doc, i) => (
                          <div key={i}> <Link to={`/docs/${slugify(doc)}`}>{t(doc)}</Link> </div>
                        ))}

                    </div>
                  )}

                </div>
              </div>
            )}
          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Content;
